import validator from 'validator';

const validatePassword = (password) => {
  const regex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/gm;

  return regex.test(password);
};

export const newPasswordValid = (
  password,
  confirmPassword,
  updaterCallbackFn
) => {
  if (!password?.length) {
    return false;
  }
  const username = sessionStorage.getItem('username');

  const trimmedPassword = password.trim();
  let error = '';
  const isLengthError =
    !validator.isLength(trimmedPassword, { min: 8 }) || password.includes(' ');
  const passwordsMismatch = password !== confirmPassword;
  const consistsUsername = trimmedPassword.includes(username);
  const consistsDeprecatedWords =
    trimmedPassword.includes('nakednews') ||
    trimmedPassword.includes('tempted') ||
    trimmedPassword.substring(0, 8) === 'password';
  const isInvalidPassword = !validatePassword(trimmedPassword);

  if (isLengthError) {
    error =
      "Password needs to be at least 8 characters long and shouldn't contain spaces";
  }
  if (passwordsMismatch) {
    error = 'Passwords do not match';
  }
  if (consistsUsername) {
    error = 'Password must be different than your username';
  }
  if (consistsDeprecatedWords) {
    error =
      "Password shouldn't start with 'password' and should not contain 'nakednews' or 'tempted'";
  }
  if (isInvalidPassword) {
    error = 'Password should contain at least one letter, one number';
  }

  if (updaterCallbackFn) {
    updaterCallbackFn(error);
  }

  if (error) {
    return false;
  }

  return true;
};
